export default "__VITE_ASSET__RC3AneKR__"